    import React, { Component } from 'react';

    import { isAposFimInscricaoFimPagamento } from '../../helper/ContextHelper';

    import Grid from '@material-ui/core/Grid';

    import Table, { DataTableLineTotals as Totals } from '../../components/Table/Table';

    import { numberFormat } from '../../helper/MaskHelper';

    import { 
        ButtonNewTabCandidatosPorUf,
        ButtonNewTabCandidatosPorUfAndStatus,
        ButtonNewTabCandidatosPorUfAndDepAdmin,
        ButtonNewTabCandidatos,
        ButtonNewTabCandidatosPorStatus,
        ButtonNewTabCandidatosPorDepAdmin,
    } from '../Buttons/ButtonsNewTab';

    export class DadosUfs extends Component {
        sumUfs = () => this.props.ufs.length;
        sumMunicipios = () => this.props.ufs.reduce((total, mun) => total + mun.municipios, 0);
        sumCandidatos = () => this.props.ufs.reduce((total, mun) => total + mun.candidatos, 0);
        sumCandidatosInscritos = () => this.props.ufs.reduce((total, mun) => total + mun.candidatosInscritos, 0);
        sumCandidatosAguardandoPagamento = () => this.props.ufs.reduce((total, mun) => total + mun.candidatosAguardandoPagamento, 0);
        sumCandidatosComPendencias = () => this.props.ufs.reduce((total, mun) => total + mun.candidatosComPendencias, 0);
        sumCandidatosNaoFinalizados = () => this.props.ufs.reduce((total, mun) => total + mun.candidatosNaoFinalizados, 0);
        sumEscolasPublicas = () => this.props.ufs.reduce((total, mun) => total + mun.escolasPublicas, 0);
        sumEscolasPrivadas = () => this.props.ufs.reduce((total, mun) => total + mun.escolasPrivadas, 0);

        handlePage = (value) => this.setState({ ...this.state, page: value, });
        handleRowsPerPage = (value) => this.setState({ ...this.state, size: value, page: 0, });
        handleTotalPages = () => Math.ceil(this.props.ufs.length / this.state.size);
        handleTotalElements = () => this.props.ufs.length;

        newTabCandidatosPorUf = (qtd, uf, query = "") => {
            if (!uf)
                return <ButtonNewTabCandidatos qtd={numberFormat(qtd)} query="&comLocalProvaSelecionado=false" />;

            return <ButtonNewTabCandidatosPorUf qtd={numberFormat(qtd)} uf={uf} query={query} />
        }

        newTabCandidatosPorUfAndStatus = (qtd, uf, status, query = "") => {
            if (!uf)
                return <ButtonNewTabCandidatosPorStatus qtd={numberFormat(qtd)} status={status} query="&comLocalProvaSelecionado=false" />;

            return <ButtonNewTabCandidatosPorUfAndStatus qtd={numberFormat(qtd)} uf={uf} status={status} query={query} />
        }
        
        newTabCandidatosPorUfAndDepAdmin = (qtd, uf, depAdmin, query = "") => {
            if (!uf)
                return <ButtonNewTabCandidatosPorDepAdmin qtd={numberFormat(qtd)} depAdmin={depAdmin} query="&comLocalProvaSelecionado=false" />;

            return <ButtonNewTabCandidatosPorUfAndDepAdmin qtd={numberFormat(qtd)} uf={uf} depAdmin={depAdmin} query={query} />
        }

        render () {
            const columns = [
                { label: 'UF', name: 'uf', func: (value) => value ?? "Sem UF Informada", key: true, witdh: '12', orderLabel: 'asc', },
                { label: 'Candidatos', name: 'candidatos', func: (qtd, uf) => this.newTabCandidatosPorUf(qtd, uf), key: false, width: '11', },            
                { label: 'Inscrições Finalizadas', name: 'candidatosInscritos', func: (qtd, uf) =>  this.newTabCandidatosPorUfAndStatus(qtd, uf, "FINALIZADO"), key: false, width: '11', },
                { label: 'Inscrições Aguardando Pagamento', name: 'candidatosAguardandoPagamento', func: (qtd, uf) => this.newTabCandidatosPorUfAndStatus(qtd, uf, "AGUARDANDO_PAGAMENTO"), key: false, width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
                { label: 'Inscrições Com Pendências', name: 'candidatosComPendencias', func: (qtd, uf) => this.newTabCandidatosPorUfAndStatus(qtd, uf, "INICIADO"), key: false, width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
                { label: 'Inscrições Não Finalizadas', name: 'candidatosNaoFinalizados', func: (qtd, uf) => this.newTabCandidatosPorUfAndStatus(qtd, uf, "INCOMPLETO", "&comEscolaSelecionada=true&comLocalProvaSelecionado=true"), key: false, width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
                { label: 'Total de Escolas Públicas', name: 'escolasPublicas', func: (qtd, uf) => this.newTabCandidatosPorUfAndDepAdmin(qtd, uf, "PUBLICA"), key: false, width: '11' },
                { label: 'Total de Escolas Privadas', name: 'escolasPrivadas', func: (qtd, uf) => this.newTabCandidatosPorUfAndDepAdmin(qtd, uf, "PRIVADA"), key: false, width: '11' },
                { label: 'Total de Municípios', name: 'municipios', func: null, key: false, width: '11', },
            ];
            
            const actions = [];
            
            const totals = [           
                { column: 0, label: 'UF', value: numberFormat(this.sumUfs()), width: '12', },                
                { column: 1, label: 'Candidatos', value: numberFormat(this.sumCandidatos()), width: '11', },            
                { column: 2, label: 'Inscrições Finalizadas', value: numberFormat(this.sumCandidatosInscritos()), width: '11', },
                { column: 3, label: 'Inscrições Aguardando Pagamento', value: numberFormat(this.sumCandidatosAguardandoPagamento()), width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },            
                { column: 4, label: 'Inscrições Com Pendências', value: numberFormat(this.sumCandidatosComPendencias()), width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
                { column: 5, label: 'Inscrições Não Finalizadas', value: numberFormat(this.sumCandidatosNaoFinalizados()), width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
                { column: 6, label: 'Total de Escolas Públicas', value: numberFormat(this.sumEscolasPublicas()), width: '11', },
                { column: 7, label: 'Total de Escolas Privadas', value: numberFormat(this.sumEscolasPrivadas()), width: '11', },
                { column: 8, label: 'Total de Municípios', value: numberFormat(this.sumMunicipios()), width: '11', },
            ];

            return (
                <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                    <Grid item xs={12}>
                        <Table              
                            columns={columns}
                            tableData={this.props.ufs}
                            actions={actions}
                            page={null}
                            rowsPerPage={null}
                            sort={null}
                            fixedHeader={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Totals lineData={totals} columns={columns} showHead={true} />
                    </Grid>
                </Grid>
            )
        }
    }

    export default DadosUfs;